import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-tasks',
  templateUrl: './main-tasks.component.html',
  styleUrls: ['./main-tasks.component.scss']
})
export class MainTasksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
